export const messages = {
  en: {
    transactionLogManage: {
      queryCondition: 'Query Condition',
      transactionLog: 'Transaction Log',
      placeholder: {
        transactionId: 'Please enter transaction ID',
        appId: 'Please enter app ID',
        serviceCode: 'Please enter service code'
      },
      table: {
        transactionId: 'Transaction ID',
        srcIp: 'Source IP',
        appId: 'App ID',
        serviceCode: 'Service Code',
        costTime: 'Cost Time',
        state: 'State',
        createTime: 'Create Time'
      },
      state: {
        success: 'Success',
        fail: 'Fail'
      },
      viewMessage: 'View Message',
      fetchError: 'Failed to fetch transaction logs'
    }
  },
  zh: {
    transactionLogManage: {
      queryCondition: '查询条件',
      transactionLog: '交互日志',
      placeholder: {
        transactionId: '请输入流水',
        appId: '请输入应用编码',
        serviceCode: '请输入服务编码'
      },
      table: {
        transactionId: '流水',
        srcIp: '源IP',
        appId: '应用编码',
        serviceCode: '服务编码',
        costTime: '耗时',
        state: '状态',
        createTime: '请求时间'
      },
      state: {
        success: '成功',
        fail: '失败'
      },
      viewMessage: '查看报文',
fetchError: '获取交互日志失败'
    }
  },
  'zh-TW': {
    transactionLogManage: {
      queryCondition: '查詢條件',
      transactionLog: '交互日誌',
      placeholder: {
        transactionId: '請輸入流水',
        appId: '請輸入應用編碼',
        serviceCode: '請輸入服務編碼'
      },
      table: {
        transactionId: '流水',
        srcIp: '源IP',
        appId: '應用編碼',
        serviceCode: '服務編碼',
        costTime: '耗時',
        state: '狀態',
        createTime: '請求時間'
      },
      state: {
        success: '成功',
        fail: '失敗'
      },
      viewMessage: '查看報文',
      fetchError: '獲取交互日誌失敗'
    }
  }
}